<template>
    <div id="indexTextProtocol" class="service-agreement">
        <van-nav-bar
            :title="title"
            class="z-index_max title"
            :border="false"
            left-arrow
            fixed
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <InquiryAgreement v-if="title==='问诊知情同意书'"/>
        <HospitalAgreement v-if="title==='宜贰叁互联网医院服务协议'"/>
    </div>
</template>

<script>
    import InquiryAgreement from '@/components/service/inquiryAgreement';
    import HospitalAgreement from '@/components/service/hospitalAgreement';
    export default {
        props:{
            title:String,
        },
        data(){
            return {
                
            }
        },
        components:{
            InquiryAgreement,
            HospitalAgreement
        },
        methods:{
            onClickLeft(){
                this.$emit('callback')
            }
        }
    }
</script>

<style scoped lang="scss">
#indexTextProtocol.service-agreement{
    width:calc(100% - 20px);
    height:100vh;
    background:white;
    position:fixed;
    top:0;
    overflow: scroll;
    .z-index_max{
        z-index:999999!important;
    }
}

.service-agreement {
    padding: 50px 10px;
}
  .service-agreement /deep/ {
    h4 {
      font-size: 16px;
    }
    h5 {
      font-size: 14px;
    }
    p {
      font-size: 14px;
      text-indent: 2em;
    }
    @media screen and (min-width: 1000px) {
      h4 {
        font-size: 8px;
      }
      h5 {
        font-size: 6px;
      }
      p {
        text-indent: 2em;
        font-size: 6px;
      }
    }
  } 
</style>